export default __webpack_public_path__ + "static/community-events-section-hero-ddb8d42b23221df84c72513f4b340097.png";